import BaseMessageHandler from '../BaseMessageHandler';
import { updateDataItem } from 'actions/getData';

export default class User_Enable extends BaseMessageHandler {
  success = () => {
    const { dispatch, message } = this;
    dispatch(updateDataItem('users', 'id', message.payload));
  };
}
